var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "LessonEntityDetails__Component" },
    [
      _c(
        "b-field",
        { attrs: { label: "שאלה" } },
        [
          _c("NewActivityEditor", {
            ref: "editor",
            attrs: {
              ckEditorContent: _vm.model.question,
              content: _vm.model.question,
            },
            on: { onEditorChange: _vm.onEditorChange },
          }),
        ],
        1
      ),
      _c("FieldInlineText", {
        attrs: { label: "הערות עורך" },
        on: { onChange: _vm.onChange },
        model: {
          value: _vm.model.editorNotes,
          callback: function ($$v) {
            _vm.$set(_vm.model, "editorNotes", $$v)
          },
          expression: "model.editorNotes",
        },
      }),
      _c(
        "b-checkbox",
        {
          on: { input: _vm.onChange },
          model: {
            value: _vm.model.isDelta,
            callback: function ($$v) {
              _vm.$set(_vm.model, "isDelta", $$v)
            },
            expression: "model.isDelta",
          },
        },
        [_vm._v("דלתא ")]
      ),
      _c(
        "div",
        { staticClass: "checkbox-container" },
        [
          _c(
            "b-checkbox",
            {
              on: { input: _vm.onChange },
              model: {
                value: _vm.model.isInExam,
                callback: function ($$v) {
                  _vm.$set(_vm.model, "isInExam", $$v)
                },
                expression: "model.isInExam",
              },
            },
            [_vm._v("שאלת אמת ")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "checkbox-container" },
        [
          _c(
            "b-switch",
            {
              staticClass: "ltr",
              on: { input: _vm.onChange },
              model: {
                value: _vm.model.status,
                callback: function ($$v) {
                  _vm.$set(_vm.model, "status", $$v)
                },
                expression: "model.status",
              },
            },
            [_vm._v(_vm._s(_vm.model.status ? "פעיל" : "לא פעיל"))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }